import React, { useEffect, useState } from 'react';
import { Box, ToggleButton, ToggleButtonGroup, useMediaQuery, useTheme } from '@mui/material';
import ViewListIcon from '@mui/icons-material/ViewList';
import MapIcon from '@mui/icons-material/Map';
import { useNavigate } from 'react-router-dom';
import MasterAssetList from './MasterAssetList';
import MasterAssetMap from './MasterAssetMap';
import PageShell from '../../themes/components/PageShell';
import PageHeader from '../../themes/components/PageHeader';
import PageContent from '../../themes/components/PageContent';

const MasterAssetSwitch = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [viewMode, setViewMode] = useState(isMobile ? 'list' : 'map');

  useEffect(() => {
    if (isMobile) {
      setViewMode('list');
    }
  }, [isMobile]);

  const handleViewChange = (_, nextView) => {
    if (nextView) {
      setViewMode(nextView);
    }
  };

  return (
    <PageShell>
      <PageHeader
        title="Assets"
        back
        onBack={() => navigate('/')}
        actions={
          <ToggleButtonGroup
            size="small"
            exclusive
            value={viewMode}
            onChange={handleViewChange}
            aria-label="Asset view"
          >
            <ToggleButton value="list" aria-label="Show asset list">
              <ViewListIcon fontSize="small" sx={{ mr: { xs: 0, sm: 0.75 } }} />
              <Box component="span" sx={{ display: { xs: 'none', sm: 'inline' } }}>
                List
              </Box>
            </ToggleButton>
            <ToggleButton value="map" aria-label="Show asset map">
              <MapIcon fontSize="small" sx={{ mr: { xs: 0, sm: 0.75 } }} />
              <Box component="span" sx={{ display: { xs: 'none', sm: 'inline' } }}>
                Map
              </Box>
            </ToggleButton>
          </ToggleButtonGroup>
        }
      />

      <PageContent
        fill={viewMode === 'map'}
        sx={{
          p: viewMode === 'list' ? { xs: 2, md: 3 } : 0,
        }}
      >
        {viewMode === 'map' ? <MasterAssetMap /> : <MasterAssetList />}
      </PageContent>
    </PageShell>
  );
};

export default MasterAssetSwitch;
